/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PurchaseLayout_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BaseLayout_viewer">;
    readonly " $refType": "PurchaseLayout_viewer";
};
export type PurchaseLayout_viewer$data = PurchaseLayout_viewer;
export type PurchaseLayout_viewer$key = {
    readonly " $data"?: PurchaseLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PurchaseLayout_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PurchaseLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "country",
      "type": "String!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BaseLayout_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "country",
          "variableName": "country"
        }
      ]
    }
  ]
};
(node as any).hash = '3b959cb30827e1ff87f3897751ec3b3d';
export default node;
